import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import styles from './DescriptionModal.module.css';

Modal.setAppElement('#root');

const DescriptionModal = ({ isOpen, onClose, onSave, defaultDescription = 'Untitled' }) => {
  const [description, setDescription] = useState(defaultDescription);

  useEffect(() => {
    if (isOpen) {
      setDescription(defaultDescription);
    }
  }, [isOpen, defaultDescription]);

  const handleSubmit = (shouldSave) => {
    if (shouldSave) {
      onSave(description);
    } else {
      onSave('Untitled'); // Skip was clicked, use default
    }
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
    >
      <div className={styles.content}>
        <h2>Add Image Description</h2>
        <input
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter image description..."
          className={styles.input}
          autoFocus
        />
        <div className={styles.buttons}>
          <button 
            className={styles.saveButton}
            onClick={() => handleSubmit(true)}
          >
            Save
          </button>
          <button 
            className={styles.skipButton}
            onClick={() => handleSubmit(false)}
          >
            Skip
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DescriptionModal;